export const languages = [
  {
    value: "en",
    label: "English",
  },
  {
    value: "id",
    label: "Indonesia",
  },
] as const;
